import React from 'react';
import { Link } from 'react-router-dom';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Button } from '../ui/Button';
import { Building2, User, ArrowRight, Monitor, Users, GraduationCap, DollarSign, Map, Scale } from 'lucide-react';
const pathways = [{
  id: 'business',
  label: 'For Businesses',
  title: 'Build with clarity.',
  subtitle: 'Unbiased reviews of the tools and services that power D2D operations.',
  icon: Building2,
  badge: 'Browse 20+ Business Guides',
  features: [{
    icon: Monitor,
    text: 'CRM & POS system breakdowns',
    link: '/category/crms'
  }, {
    icon: Users,
    text: 'Recruiting service evaluations',
    link: '/category/recruiting'
  }, {
    icon: GraduationCap,
    text: 'Training platform reviews',
    link: '/category/training'
  }],
  cta: 'Explore Business Guides',
  ctaLink: '/category/crms'
}, {
  id: 'reps',
  label: 'For Sales Reps',
  title: 'Choose with confidence.',
  subtitle: 'Honest comparisons to help you plant your flag in the right place.',
  icon: User,
  badge: 'Browse 25+ Rep Guides',
  features: [{
    icon: Map,
    text: 'Industry-by-industry comparisons',
    link: '/category/industries'
  }, {
    icon: DollarSign,
    text: 'Compensation structure analysis',
    link: '/category/compensation'
  }, {
    icon: Scale,
    text: 'Risk vs. reward breakdowns',
    link: '/category/work-models'
  }],
  cta: 'Explore Rep Guides',
  ctaLink: '/category/industries'
}];
export function AudiencePathwaysSection() {
  return <SectionWrapper background="muted" id="pathways" data-id="element-103">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-104">
        {pathways.map(pathway => <div key={pathway.id} className="group relative bg-white border border-slate-200 rounded-lg p-8 hover:border-teal-200 hover:shadow-md transition-all duration-300" data-id="element-105">
            {/* Top accent bar */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-teal-600 rounded-t-lg opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-106" />

            <div className="flex justify-between items-start mb-6" data-id="element-107">
              <div className="flex items-center gap-3" data-id="element-108">
                <div className="p-2 bg-slate-100 rounded-lg text-slate-700 group-hover:bg-teal-50 group-hover:text-teal-700 transition-colors" data-id="element-109">
                  <pathway.icon className="w-5 h-5" data-id="element-110" />
                </div>
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-111">
                  {pathway.label}
                </span>
              </div>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-112">
                {pathway.badge}
              </span>
            </div>

            <h3 className="text-2xl font-bold text-slate-900 mb-2 tracking-tight" data-id="element-113">
              {pathway.title}
            </h3>
            <p className="text-slate-600 mb-8 text-sm leading-relaxed" data-id="element-114">
              {pathway.subtitle}
            </p>

            <div className="space-y-3 mb-8" data-id="element-115">
              {pathway.features.map((feature, index) => <Link key={index} to={feature.link} className="flex items-center justify-between group/item hover:bg-slate-50 p-2 -mx-2 rounded-md transition-colors" data-id="element-116">
                  <div className="flex items-center gap-3" data-id="element-117">
                    <feature.icon className="w-4 h-4 text-slate-400 group-hover/item:text-teal-600 transition-colors" data-id="element-118" />
                    <span className="text-sm text-slate-700 font-medium" data-id="element-119">
                      {feature.text}
                    </span>
                  </div>
                  <ArrowRight className="w-3 h-3 text-slate-300 group-hover/item:text-teal-600 opacity-0 group-hover/item:opacity-100 transition-all" data-id="element-120" />
                </Link>)}
            </div>

            <Link to={pathway.ctaLink} data-id="element-121">
              <Button variant="outline" className="w-full group/btn border-slate-200 hover:border-teal-200 hover:bg-teal-50 hover:text-teal-800" data-id="element-122">
                {pathway.cta}
                <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" data-id="element-123" />
              </Button>
            </Link>
          </div>)}
      </div>
    </SectionWrapper>;
}